var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.121,
    height: 53.133,
    viewBox: "0 0 79.121 53.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_726",
    "data-name": "Groupe 726",
    transform: "translate(-86.939 -152.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1810",
    "data-name": "Rectangle 1810",
    width: 77,
    height: 51.012,
    transform: "translate(88 153.4)",
    strokeWidth: 1.5,
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2170",
    "data-name": "Trac\\xE9 2170",
    d: "M88,153.4l38.5,38.639L165,153.4",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_29",
    "data-name": "Ligne 29",
    x2: 25.412,
    y2: 25.504,
    transform: "translate(139.588 178.908)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_30",
    "data-name": "Ligne 30",
    y1: 25.506,
    x2: 25.414,
    transform: "translate(88 178.906)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.37197c213077f04cab5f8f26dcc80c82.svg";
export { ForwardRef as ReactComponent };